import { NO_WAIT_MARKS_LABEL } from "@/utils/dealerWaitThresholds";

export const NO_WAIT_MINUTES = 0;

export const describeWait = (row) => (row.has_marks ? row.wait_minutes : NO_WAIT_MARKS_LABEL);

export const isCountedRoute = (row) => row.excess_minutes !== null;

export const describeExcess = (row) => (isCountedRoute(row) ? row.excess_minutes : NO_WAIT_MARKS_LABEL);

export const countNotCountedRoutes = (routes) => routes.filter((row) => !isCountedRoute(row)).length;
